import * as React from "react";
import { Column } from "primereact/column";
import { Row, Col } from "reactstrap";
import PageLayout from "../../components/PageLayout";
import { useParams, useHistory } from "react-router-dom";
import { getList } from "../../api/search";
import { DataTable } from "primereact/datatable";
import roles from "../../auth/roles";
import { addUserToTenant, getUsersForTenant } from "../../api/users";
import { DropdownFilterElement } from "../../components/TableUtils";
import { getRolesDomain } from "../../auth/roles";
import classNames from 'classnames';

export default function UserPicker({ opt }) {

  let dtable;

  const { parent, role } = useParams();
  const [result, setResult] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const { push } = useHistory();

  async function loadData() {
    setLoading(true);
    try {
      const roleFilter = role === roles.VENDITORE ? `role in ('${roles.VENDITORE}', '${roles.AGENTE}')` : `role='${role}'`
      const items = await getList("users", "users.attributes -> 'surname', users.attributes -> 'name' asc", roleFilter);
      let idToExclude = await getUsersForTenant(role, parent);
      idToExclude = idToExclude.map(el => el.user_id);
      const users = items.filter(u => !idToExclude.includes(u._id));
      setResult(users);
    } finally {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    loadData();
  }, [true]);

  const selectEntity = async user => {
    const proceed = confirm(`Confermi l'associazione con ${user.value.attributes.surname} ${user.value.attributes.name} - ${(user.value.attributes.role).toUpperCase()}?`);
    if (!proceed) return;
    setLoading(true);
    try {
      await addUserToTenant({
        userId: user.value._id,
        tenantId: parent,
        type: role
      });
      await loadData();
    } finally {
      push("/tenant/structure");
    }
  };

  return (
    <PageLayout
      title={`Selezionare il nominativo ${role.toUpperCase()} da associare:`}
      optionalNav={{
        link: `/admin/tenants-hierarchy/${parent}`,
        text: "Struttura"
      }}
    >
      <Row>
        <Col>
          <DataTable
            ref={el => {
              dtable = el;
            }}
            loading={loading}
            value={result}
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            className="p-datatable-hoverable-rows p-datatable-customers p-datatable-pointer"
            emptyMessage={() => (<div className="text-center">Nessun Utente in tabella</div>)}
            responsive
            paginator={true}
            autoLayout={false}
            first={0}
            rows={20}
            totalRecords={result.length}
            paginatorPosition="both"
            selectionMode="single"
            onSelectionChange={selectEntity}
            value={result}
            paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
            currentPageReportTemplate="Visualizzati {first} di {last} Utenti su un totale di {totalRecords}"
          >
            <Column
              field="attributes.surname"
              style={{ wordWrap: "break-word" }}
              header="Cognome"
              sortable
              filter
            />
            <Column
              field="attributes.name"
              style={{ wordWrap: "break-word" }}
              header="Nome"
              sortable
              filter
            />
            <Column
              field="attributes.email"
              header="Email"
              sortable
              filter
              style={{ wordWrap: "break-word" }}
            />
            <Column
              field="attributes.phone"
              header="Telefono"
              sortable
              filter
              style={{ wordWrap: "break-word" }}
            />
            <Column
              field="role"
              header="Ruolo"
              sortable
              filter
              filterElement={
                <DropdownFilterElement
                  field="role"
                  options={getRolesDomain()}
                  onChange={e => dtable.filter(e.value, e.field, e.type)}
                />
              }
              body={(rowData, column) => {
                return (
                  <span className={classNames('customer-badge', 'role-' + rowData.role)}>{rowData.role}</span>
                );
              }}
              style={{ wordWrap: "break-word", textAlign: "center" }}
            />
          </DataTable>
        </Col>
      </Row>
    </PageLayout >
  );
}
